import { Box, Container, Icon, Link, SpaceBetween } from '@cloudscape-design/components';
import { ReviewText } from './ReviewText';
import { StarsIcon } from './StarsIcon';
import { useMemo } from 'react';
import { formatSourceName } from '../common/formatting/sourceFormat';
import { GoogleIcon } from '../common/icons/GoogleIcon';
import { BBBIcon } from '../common/icons/BBBIcon';
import { DealerRaterIcon } from '../common/icons/DealerRaterIcon';
import { YelpIcon } from '../common/icons/YelpIcon';
import { CarsComIcon } from '../common/icons/CarsComIcon';
import { CarFaxIcon } from '../common/icons/CarFaxIcon';
import { EdmundsIcon } from '../common/icons/EdmundsIcon';
import { CarGurusIcon } from '../common/icons/CarGurusIcon';
import { OpenTableIcon } from '../common/icons/OpenTableIcon';
import { TripAdvisorIcon } from '../common/icons/TripAdvisorIcon';
import { BookingIcon } from '../common/icons/BookingIcon';
import { ExpediaIcon } from '../common/icons/ExpediaIcon';
import { GolfPassIcon } from '../common/icons/GolfPassIcon';

export type ReviewContentProps = {
  review_id?: string;
  text?: string | null;
  stars?: number;
  highlights?: string[];
  recency?: string;
  highlightCaseSensitive?: boolean;
  truncateCharacters?: number;
  displaySource?: boolean;
  source?: string;
  link?: string;
};

export function ReviewContent(props: ReviewContentProps) {
  const {
    review_id,
    text,
    stars,
    highlights,
    recency,
    highlightCaseSensitive,
    truncateCharacters,
    displaySource,
    source,
    link,
  } = props;


  const formattedSource = useMemo(() => {
    if (!source) {
      return undefined;
    }
    const formattedSource = formatSourceName(source);
    let sourceIcon = undefined;
    if (source === 'google') {
      sourceIcon = <GoogleIcon />;
    } else if (source === 'yelp') {
      sourceIcon = <YelpIcon />;
    } else if (source === 'bbb') {
      sourceIcon = <BBBIcon />;
    } else if (source === 'dealerrater') {
      sourceIcon = <DealerRaterIcon />;
    } else if (source === 'carscom') {
      sourceIcon = <CarsComIcon />;
    } else if (source === 'carfax') {
      sourceIcon = <CarFaxIcon />;
    } else if (source === 'edmunds') {
      sourceIcon = <EdmundsIcon />;
    } else if (source === 'cargurus') {
      sourceIcon = <CarGurusIcon />;
    } else if (source === 'opentable') {
      sourceIcon = <OpenTableIcon />;
    } else if (source === 'tripadvisor') {
      sourceIcon = <TripAdvisorIcon />;
    } else if (source === 'booking') {
      sourceIcon = <BookingIcon />;
    } else if (source === 'expedia') {
      sourceIcon = <ExpediaIcon />;
    } else if (source === 'golfpass') {
      sourceIcon = <GolfPassIcon />;
    }
    if (sourceIcon) {
      return (
        <SpaceBetween direction="horizontal" size="xxxs">
          <Icon svg={sourceIcon} />
          <Box variant="span">{formattedSource}</Box>
        </SpaceBetween>
      );
    }
    return (
      formattedSource
    );
  }, [source]);


  const recencyLink = (
    link ? <Link href={link} target="_blank" variant="secondary">{recency}</Link> : recency
  )

  return (
    <SpaceBetween direction="vertical" size="xxxs">
      <SpaceBetween direction="horizontal" size="xs">
        {stars !== undefined ? (
          <SpaceBetween direction="horizontal" size="xs">
            <StarsIcon stars={stars} />
            {/* {' | '} */}
            <Box variant="span">{recencyLink}</Box>
          </SpaceBetween>
        ) : (
          <Box variant="span">{recencyLink}</Box>
        )}
        {displaySource && (
          <SpaceBetween direction="horizontal" size="xs">
            {/* {' | '} */}
            <Box variant="span">{formattedSource}</Box>
          </SpaceBetween>
        )}
        {/* <Link variant="secondary" href={`https://maps.app.goo.gl/${review_id}`}>View</Link> */}
      </SpaceBetween>
      <ReviewText
        text={text}
        highlights={highlights}
        highlightCaseSensitive={highlightCaseSensitive}
        maxCharacters={truncateCharacters}
      />
    </SpaceBetween>
  );
}
